import { PayloadAction } from '@reduxjs/toolkit';
import { changeOrganizacion as changeOrganizacionAction } from '../../api/miembros/changeOrganizacion';
import { GenericState } from '../../types/apiModule';
import { User } from '../../types/users/users';
import createApiModule from '../createApiModule';
import { showSnackBar } from '../snackBar/snackBarSlice';
import { listMiembrosRefresh } from './listMiembrosModule';
import { t } from '../../i18n';
export interface changeOrganizacionState extends GenericState<unknown> {
  active: boolean;
  user: User;
}
const initialState: changeOrganizacionState = {
  errors: null,
  data: [],
  loading: false,
  active: false,
  user: {} as User,
};

const changeOrganizacionModule = createApiModule({
  name: 'changeOrganizacion',
  initialState,
  apiMethod: changeOrganizacionAction,
  onSuccess: () => [
    showSnackBar({
      severity: 'success',
      message: t('MESSAGE_MIEMBRO_CAMBIO_ORGANIZACION'),
    }),
    listMiembrosRefresh(),
  ],
  onError: () => ({
    message: t(
      'StoreMiembrosChangeOrganizacionModuleErrorCambiandoElMiembroADeOrganizacion',
    ),
  }),
  onValidationError: () => ({
    message: t(
      'StoreMiembrosChangeOrganizacionModuleErrorCambiandoElMiembroADeOrganizacion',
    ),
  }),
  reducers: {
    show(state, action: PayloadAction<User>) {
      state.active = true;
      state.user = action.payload;
    },
    hide(state) {
      state.active = false;
    },
  },
});

export const {
  start: changeOrganizacion,
  success: changeOrganizacionOk,
  error: changeOrganizacionKo,
  hide,
  show,
} = changeOrganizacionModule.slice.actions;

export default changeOrganizacionModule;
